<template>
  <v-select
    :items="languages"
    :label="t('language')"
    outlined
    :placeholder="t('language')"
    v-model="language"
    background-color="white"
    disabled
    v-show="false"
  >
    <template #selection="{ item }">
      <v-avatar
        tile
        class="align-start"
      >
        <v-img :src="require('@/assets/flag-' + item.img + '.svg')" />
      </v-avatar>
      <span class="pl-3">{{ item.text }}</span>
    </template>
    <template #item="{ item }">
      <v-avatar
        tile
        class="align-start"
      >
        <v-img :src="require('@/assets/flag-' + item.img + '.svg')" />
      </v-avatar>
      <span class="pl-3">{{ item.text }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SelectLanguage',

  data: () => ({
    languages: [
      {
        text: 'Deutsch',
        value: 'de',
        img: 'de'
      },
      {
        text: 'Gebärdensprache',
        value: 'deg',
        img: 'de'
      },
      {
        text: 'Leichte Sprache',
        value: 'del',
        img: 'de'
      },
      {
        text: 'English',
        value: 'en',
        img: 'en'
      }
    ]
  }),

  computed: {
    language: {
      get () {
        return this.$vuetify.lang.current
      },
      set (value) {
        // this.$emit('before-change-language')
        this.$vuetify.lang.current = value
        // this.$emit('after-change-language')
      }
    }
  },

  methods: {
    t (value) {
      return this.$vuetify.lang.t('$vuetify.' + value)
    }
  }
}
</script>

<style scoped>

</style>
